import { Component, OnInit, OnDestroy } from '@angular/core';
import { TokenManager } from '../Globals';
import { LoginService } from '../services/login.service';
import { NgProgress, NgProgressRef } from '@ngx-progressbar/core';
import { Globals } from '../objects/Globals';
import { Router } from '@angular/router';
import { MainLoadingService } from '../services/main-loading.service';
import { WorkflowReturnService } from '../services/workflow-return.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.css']
})
export class LogoComponent implements OnInit, OnDestroy {

  progressRef: NgProgressRef;
  subRouter: Subscription;
  startPage: boolean = false;
  
  constructor(private tokenManager:TokenManager, private loginService:LoginService, private progress:NgProgress, private globals:Globals, private router:Router, 
    private mainLoadingService: MainLoadingService, private workflowReturnService: WorkflowReturnService) { 
      this.subRouter = router.events.subscribe((val) => {
        if (router.url.indexOf("/khamis-start") > -1){
          this.startPage = true;
        }
        else{
          this.startPage = false;
        }
      });

    }

  ngOnInit() {
    this.progressRef = this.progress.ref('progressBar');
  }

  goToHome(){
    if (!this.startPage){
      this.tokenManager.store("BRNCurrentMenu", "Home");
      this.mainLoadingService.setProgressBar(true);
      this.loginService.getHomePage().subscribe(result=>{
        var command = JSON.parse(result);
        this.workflowReturnService.handleWorkflowReturn(command, true, true);
        this.mainLoadingService.setProgressBar(false);
      });
    }
  }

  ngOnDestroy(){
    if (this.subRouter) this.subRouter.unsubscribe();
  }
}
